import React from 'react';
import AuthCard from '../AuthCard';
import ForgotPasswordRequestForm, {
  ForgotPasswordRequestFormProps,
} from '../ForgotPasswordRequestForm';
import {
  FORGOT_PASSWORD_REQUEST_CARD_SUBTITLE,
  FORGOT_PASSWORD_REQUEST_CARD_TITLE,
} from './constants';

export interface ForgotPasswordRequestCardProps
  extends Pick<ForgotPasswordRequestFormProps, 'onSubmit' | 'onSuccess'> {}

/**
 * A card that submits a "forgot-password request".
 */
const ForgotPasswordRequestCard: React.FC<ForgotPasswordRequestCardProps> = ({
  onSubmit,
  onSuccess,
}) => (
  <AuthCard
    header={
      <AuthCard.Header
        title={FORGOT_PASSWORD_REQUEST_CARD_TITLE}
        subtitle={FORGOT_PASSWORD_REQUEST_CARD_SUBTITLE}
      />
    }
  >
    <AuthCard.Contents>
      <ForgotPasswordRequestForm {...{ onSubmit, onSuccess }} />
    </AuthCard.Contents>
  </AuthCard>
);

export default ForgotPasswordRequestCard;
